import { useEffect, useState } from "react";
import { Modal, Tag } from "antd";

import {
  getProfile,
  hasTokenExpired,
  logout,
  extendSession,
} from "@seims/shared/src/security";

export const TimerControl = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [color, setColor] = useState("");

  //! Access token life span is approximately 2 minutes as thus we must display a messsage before token expires
  var tokenExpiryTime = new Date(getProfile().expiryTime * 1000);

  useEffect(() => {

    const interval = setInterval(() => getTimer(), 1000);
    changeColor();

    return () => clearInterval(interval);
  }, [color, minutes, seconds]);

  const getTimer = () => {
    if (!hasTokenExpired()) {
      const time = tokenExpiryTime - Date.now();

      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    }

    if (minutes === 0 && seconds === 0) setIsOpen(false);
  };

  const changeColor = () => {
    if (minutes === 0 && seconds > 40) setColor("#00c853");
    else if (minutes === 0 && seconds < 40 && seconds > 20) setColor("#ff6f00");
    else if (minutes === 0 && seconds < 20) setColor("#d50000");
  };

  const onOk = () => {
    setIsOpen(false);
    extendSession();
  };

  const onCancel = () => {
    logout();
  };

  return (
    <>
      <Modal
        title="Your Login session is about to expire"
        width={400}
        open={minutes === 0 && seconds > 0}
        onOk={onOk}
        cancelText="Logout"
        okText="Extend Session"
        onCancel={onCancel}
        closable={false}
        maskClosable={false}
      >
        <p>
          Your session will expire in{" "}
          <Tag color={color}>
            {minutes}:{seconds}
          </Tag>
        </p>
      </Modal>
    </>
  );
};